export const API = "https://xertis.onrender.com";
export const CLIENT = "https://xertis.vercel.app";

export const symbols = {
  "award": "AWARD",
  "completion": "COMPLN",
  "participation": "PARTN",
  "others": "OTHER"
}
